import { Component, OnInit,Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.css']
})
export class TextComponent implements OnInit {

 constructor( private homepageService: HomepageService ) {}
 widgetsSetting: any = [];
 @Input() buId: number;
  ngOnInit() {
  		this.getwidgetsSetting();
  }
  	getwidgetsSetting() {
      let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
      getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'MS' && this.buId  == evt.id){
              this.widgetsSetting = evt.settings;              
             }
            
          });     
    }
}
